// Import the functions you need from the SDKs you need
import { initializeApp, getApps } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getAuth } from 'firebase/auth'; // ✅ Import Auth
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_USER_KEY,
  authDomain: "users-843bf.firebaseapp.com",
  projectId: "users-843bf",
  storageBucket: "users-843bf.firebasestorage.app",
  messagingSenderId: "997996494808",
  appId: process.env.REACT_APP_FIREBASE_USER_ID
};

// Initialize Firebase
const usersApp = getApps().find(app => app.name === 'users') ||
  initializeApp(firebaseConfig, 'users');
export const userDb = getFirestore(usersApp);
export const userAuth = getAuth(usersApp);